export const MODALS_NAME = {
    CASHIER: 'cashier',
    DEPOSIT_SURVEY: 'deposit-survey',
    EMAIL_CONFIRMED: 'email-confirmed',
    INTRO: 'intro',
    PARTNER_ADD_POSTBACK: 'partner-add-postback',
    PARTNER_UPDATE_POSTBACK: 'partner-update-postback',
    PERSONAL: 'personal',
    REGISTER_EMAIL_CHECK: 'register-email-check',
    RESET_PASSWORD: 'reset-password',
    WITHDRAWAL_REQUEST_SENT: 'withdrawal-request-sent',
};
